import Vue from "vue";
import VueResource from "vue-resource";
import App from "./App.vue";
import validator from "./services/validator.js";
// import helper from './services/helper'
import mainRouter from "./router";
import biznesRouter from "./router/biznes";
import wakacjeRouter from "./router/wakacje";
// import landingRouter from './router/landing'
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
// import './index.css'
import "./assets/tailwind.css";
Vue.use(VueResource);
window.Vue = Vue;
import "tw-elements";

const host = window.location.host;
const parts = host.split(".");

const router = () => {
  let routes;
  if (parts[0] === "wakacjekredytowe" || parts[0] === "localhost") {
    routes = wakacjeRouter;
  } else if (parts[0] === "biznes") {
    routes = biznesRouter;
  } else {
    routes = mainRouter;
  }
  return routes;
};

window.router = router();
window.router.beforeEach(function (to, from, next) {
  let split = to.fullPath.split("#");
  if (split.length > 1) {
    next({
      path: split[1],
    });
  } else {
    next();
  }
});

Bugsnag.start({
  apiKey: "578e3aa3f9c85ef436fdffda9b7aec68",
  plugins: [new BugsnagPluginVue()],
});

Vue.config.productionTip = false;

window.Vue.filter("truncate80", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 80;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate40", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 40;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate30", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 30;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate20", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 20;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});

new Vue({
  router: window.router,
  render: (h) => h(App),
  created() {
    validator.init();
  },
}).$mount("#app");
